
const LOGININ = "LOGININFO";
const LOGINOUT = "LOGINOUT";


const loginIn = () => ({
  type: LOGININ
});

const loginOut = (json: any) => ({
  type: LOGINOUT
});

export {
  LOGININ,
  LOGINOUT,
  loginIn,
  loginOut,
}